import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaChevronRight } from "react-icons/fa";
import { PiUserBold, PiCalendarBlankBold } from "react-icons/pi";
import { useQuery } from "@tanstack/react-query";
import { Footer, MarkdownParser, Navbar } from "../components";
import { GenericMarkdownLoadingSkeleton } from "../components/LoadingSkeleton";
import ErrorPage from "./ErrorPage";
import customAxios from "../utils/customAxios";
import { formatDate } from "../utils/helper";

import { styles } from "../styles";

export default function LowonganKerjaDetail() {
  const { slug } = useParams();

  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const { data, isLoading, isError } = useQuery({
    queryKey: ["jobFair", slug],

    queryFn: async () => {
      const response = await customAxios.get(`job-fairs/${slug}`);

      return response?.data?.data || null;
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  if (isError) {
    return (
      <ErrorPage
        code="500"
        titleKey="error.500_title"
        defaultTitle="Gagal Memuat Data"
        subtitleKey="error.500_subtitle"
        defaultSubtitle="Terjadi masalah saat terhubung ke server kami. Silakan coba lagi nanti atau kembali ke"
      />
    );
  }

  const Crumbs = (
    <div
      className={`${styles.textLRegularM} flex items-center gap-2 w-full text-neutral-80 mb-2`}
    >
      <Link to="/" className="hover:underline">
        beranda
      </Link>
      <FaChevronRight className="w-2" />
      <Link to="/lowongan-kerja" className="hover:underline">
        lowongan-kerja
      </Link>
      <FaChevronRight className="w-2" />
      <p className="line-clamp-1">{slug}</p>
    </div>
  );

  const renderContent = () => {
    if (isLoading) {
      return (
        <>
          <div className="w-full p-6 bg-gray-200 rounded animate-pulse"></div>
          <div className="flex items-center w-full gap-4 mt-3 mb-16">
            <div className="bg-gray-200 animate-pulse p-3 w-[200px]"></div>
            <div className="bg-gray-200 animate-pulse p-3 w-[200px]"></div>
          </div>
          <GenericMarkdownLoadingSkeleton />
        </>
      );
    }

    // TODO: EMPTY STATE
    if (!data) return null;

    const {
      title_id,
      title_en,
      short_description_id,
      short_description_en,
      description_id,
      description_en,
      created_at,
    } = data;

    return (
      <div>
        <h1 className={`text-[36px] leading-11 text-neutral-100 font-bold`}>
          {currentLanguage === "en" ? title_en : title_id}
        </h1>

        <div className="flex items-center mt-3 mb-16">
          <PiUserBold className="fill-neutral-80" />
          <p className={`${styles.textLRegular} text-neutral-80 mx-2`}>
            Admin UNIVERAL
          </p>
          <PiCalendarBlankBold className="ml-5 fill-neutral-80" />
          <p className={`${styles.textLRegular} text-neutral-80 mx-2`}>
            {formatDate(created_at)}
          </p>
        </div>

        <div className="mb-8">
          <p>
            {currentLanguage === "en"
              ? short_description_en
              : short_description_id}
          </p>
        </div>

        <MarkdownParser
          content={currentLanguage === "en" ? description_en : description_id}
        />
      </div>
    );
  };

  return (
    <>
      <Navbar />
      <main
        className={`${styles.paddingX} gap-4 flex flex-wrap justify-center py-20`}
      >
        <div className="max-w-[858px] w-full">
          {Crumbs}
          {renderContent()}
        </div>
      </main>
      <Footer />
    </>
  );
}
